import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import {IconComponent} from '../shared/icon/icon.component';
import {AuthenticationService} from '../../services/authentication/authentication.service';
import {UserModel} from '../../models/user/user.model';
import {Subject, takeUntil} from 'rxjs';
import {BreakpointObserver} from '@angular/cdk/layout';

@Component({
    selector: 'app-navigation',
    standalone: true,
    imports: [
        IconComponent,
        RouterLink
    ],
    templateUrl: './navigation.component.html',
    styleUrl: './navigation.component.sass'
})
export class NavigationComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    mobileOpen: boolean = false

    loggedInUser: UserModel = {
        email: '',
        firstName: '',
        id: '',
        lastName: '',
        mobileNumber: '',
        phoneNumber: '',
        role: '',
        skype: '',
        title: ''
    };

    docOrPatientLink: string = '';

    constructor(
        private authenticationService: AuthenticationService,
        private breakPointObserver: BreakpointObserver,
        private router: Router
    ) {
        this.breakPointObserver.observe(['(min-width: 1024px)']).subscribe( result => {
            if (result.matches) {
                this.mobileOpen = false;
            }
        })
    }

    ngOnInit(): void {
        this.loggedInUser = this.authenticationService.getUser();
        this.setUserLink(this.loggedInUser);

        switch (this.loggedInUser.role) {
            case 'admin':
                this.docOrPatientLink = '/app-administration'
                break;
            case 'patient':
                this.docOrPatientLink = '/profil'
                break;
            case 'doctor':
                this.docOrPatientLink = '/administration'
                break;
            default:
                this.docOrPatientLink = '/profil'
                break
        }
        this.authenticationService.userSubject.subscribe((user: UserModel) => {
            this.loggedInUser = user;
            this.setUserLink(this.loggedInUser);
        })
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    setUserLink(user: UserModel): void {
        switch (user.role) {
            case 'admin':
                this.docOrPatientLink = '/app-administration'
                break;
            case 'patient':
                this.docOrPatientLink = '/profil'
                break;
            case 'doctor':
                this.docOrPatientLink = '/administration'
                break;
            default:
                this.docOrPatientLink = '/profil'
                break
        }
    }

    logout(): void {
        this.authenticationService.logout()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: value => {
                    this.router.navigate(['/anmeldung'])

                },
                error: err => {
                }
            })
    }

    toggleMobileMenu(): void {
        this.mobileOpen = !this.mobileOpen
    }

    routeToLogin(): void {
        this.router.navigate(['/anmeldung'], {state: {booking: true}});
    }
}
